module.exports = __webpack_public_path__ + "static/WebApp-1.7b21b1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/web-app/assets/WebApp-1.png
// module id = 279
// module chunks = 35783957827783